/* DON'T EDIT THIS FILE: edit original and run build again */ export const createDateFromUtcDateOnlyString = (dateString: string): Date => {
  const parts = dateString.split("-").map(Number);
  if (parts.length !== 3 || parts.some((part) => isNaN(part))) {
    throw new Error("invalidDateFormat: The date must be in YYYY-MM-DD format");
  }
  const [year, month, day] = parts;
  return new Date(Date.UTC(year, month - 1, day));
};
